import { ReactElement } from 'react'
import { useWatch } from 'react-hook-form'
import { SubmitButton } from '@ui/forms'
import { CheckSettingsFormValues } from '../types'

interface Props {
  loading: boolean
  disabled?: boolean
}

/**
 * Disabled while the selection still differs and no shared settings have been
 * staged to overwrite them with — submitting then would silently save nothing.
 */
const CheckSettingsSubmitButton = ({ loading, disabled = false }: Props): ReactElement => {
  const sharedSettings = useWatch<CheckSettingsFormValues>({ name: 'sharedSettings' })

  return <SubmitButton loading={loading} disabled={disabled || !sharedSettings} />
}

export default CheckSettingsSubmitButton
